import { Injectable, inject } from '@angular/core';

import { environment } from '@environments/environment';

import { NavigationService } from '../../services/navigation/navigation.service';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard {
  private navigationService = inject(NavigationService);

  canLoad(): boolean {
    if (!environment.maintenance) {
      this.navigationService.goLanding();
      return false;
    }
    return true;
  }
}
